import React, { useState, useEffect } from 'react'
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { SaveUserEmployemntInfoinAllApplications } from '../../../AdminActionCreator.component';
import moment from 'moment';

const OtherIncomeData = [
    {label : "Yes" ,value:true},
    {label : "No" ,value:false},
]


const textFieldData = [
    { label: "Employer Type", value: "employerType", placeholder: "Enter Employer Type", type: "text", name: "employerType" },
    { label: "Monthly Income", value: "monthlyIncome", placeholder: "Enter Monthly Income", type: "number", name: "monthlyIncome" },
    { label: "Annual Income", value: "annualIncome", placeholder: "Enter Annual Income", type: "number", name: "annualIncome" },
    { label: "Other Income", value: "otherIncome", placeholder: "Enter Other Income", type: "text", name: "otherIncome" },
    { label: "Nature of Income", value: "natureOfIncome", placeholder: "Enter Nature of Income", type: "text", name: "natureOfIncome" },
    { label: "Employment Start Date", value: "businessStartDate", placeholder: "Enter Employment Start Date", type: "date", name: "businessStartDate" },

]

export default function EditPersonalDetail({ data, closePopup, customStyle, handleLoader, handleTextPopup, closeTextPopup }) {
    const [objectData, setObjectData] = useState({
        "employerType": "",
        "monthlyIncome": "",
        "annualIncome": "",
        "otherIncome": "",
        "natureOfIncome": "",
        "businessStartDate": "",

    });

    const handleInputValues = (e) => {
        const { name, value } = e.target;

        setObjectData((prev) => ({
            ...prev,
            [name]: value
        }))
    }

    useEffect(() => {
        console.log("data", data)
        if (data?.userId) {
            setObjectData({
                "employerType": data?.employerType || "",
                "monthlyIncome":data?.monthlyIncome ||  "",
                "annualIncome": data?.annualIncome || "",
                "otherIncome": data?.otherIncome == true ? "Yes" : "No"  || "",
                "natureOfIncome": data?.natureOfIncome || "",
                "businessStartDate":moment(data?.businessStartDate).format("YYYY-MM-DD") || "",
            })
        } else {
            setObjectData({
                "employerType": "",
                "monthlyIncome": "",
                "annualIncome": "",
                "otherIncome": "",
                "natureOfIncome": "",
                "businessStartDate": "",
            })
        }
    }, [])


    const handleSave = () => {
        const obj = { ...objectData, userId: data?.userId }
        handleLoader(true)
        SaveUserEmployemntInfoinAllApplications(obj, callback => {
            if (callback?.message == "success" && callback?.status == 200) {
                handleTextPopup(true, "Employment Information Updated Successfully")
            } else {
                handleTextPopup(true, "Error Updating Employment Information")
            }
            handleLoader(false)
            closeTextPopup()
        })
    }


    return (
        <>
            <div className='background-blur income' style={customStyle}>
                <div className='popup-main small-popup container-fluid dbl-border'>
                    <button className='close' onClick={e => closePopup()}>
                        &times;
                    </button>
                    <h4 style={{ color: '#000' }}>Edit Employemnt Details</h4>

                    <div className="row">
                        {
                            textFieldData && textFieldData?.map((value, index) => {
                                return (
                                    <div className="col-sm-4 col-xs-12" style={{ marginTop: '20px' }}>

                                        {
                                            value?.name !== "otherIncome" ?

                                                <TextField fullWidth id="outlined-basic" label={value?.label} variant="outlined" type={value?.type} name={value?.name} value={objectData?.[value?.value]}
                                                    placeholder={value?.placeholder} onChange={(e) => handleInputValues(e)} />
                                                :
                                                value?.name == "otherIncome" ?
                                                    <TextField fullWidth id="outlined-basic" select label={value?.label} variant="outlined" type={value?.type} name={value?.name} value={objectData?.[value?.value]} placeholder={value?.placeholder} onChange={(e) => handleInputValues(e)} >
                                                        {OtherIncomeData?.map((option) => (
                                                            <MenuItem key={option.value} value={option.label}>
                                                                {option.label}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                   
                                                            :
                                                            ""
                                        }

                                    </div>
                                )
                            })
                        }

                        <div className="col-xs-12" style={{ marginTop: '20px', textAlign: 'center' }}>
                            <button className='btn btn-primary' onClick={() => handleSave()}>Save</button>
                        </div>
                    </div>

                </div>


            </div >
        </>
    )
}
